import { forwardRef } from "react";
import type { ButtonHTMLAttributes } from "react";

import { cn } from "./utils";

export type VarianteBoton = "primario" | "secundario" | "fantasma" | "peligro";

export interface BotonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variante?: VarianteBoton;
  cargando?: boolean;
}

const clasesPorVariante: Record<VarianteBoton, string> = {
  primario: "bg-primario text-sobre-primario hover:bg-primario-hover disabled:bg-primario/50",
  secundario:
    "border border-borde bg-superficie text-texto hover:bg-superficie-2 disabled:text-texto-secundario/50",
  fantasma: "bg-transparent text-primario hover:bg-primario-suave disabled:text-texto-secundario/50",
  peligro: "bg-peligro text-sobre-primario hover:bg-peligro/90 disabled:bg-peligro/50",
};

function Espinner() {
  return (
    <svg
      className="h-4 w-4 animate-spin"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
      />
    </svg>
  );
}

export const Boton = forwardRef<HTMLButtonElement, BotonProps>(function Boton(
  { variante = "primario", cargando = false, disabled, className, children, ...resto },
  ref,
) {
  return (
    <button
      ref={ref}
      type={resto.type ?? "button"}
      disabled={disabled || cargando}
      aria-busy={cargando || undefined}
      className={cn(
        "inline-flex min-h-control items-center justify-center gap-2 rounded-control px-4 text-etiqueta",
        "transition-[transform,opacity] duration-rapida motion-reduce:transition-none",
        "disabled:cursor-not-allowed active:scale-[0.98]",
        clasesPorVariante[variante],
        className,
      )}
      {...resto}
    >
      {cargando ? <Espinner /> : null}
      {children}
    </button>
  );
});
